import type { MegaGridColumn } from './MegaGridTypes';

function cellText<T>(row: T, column: MegaGridColumn<T>): string {
    const raw = column.exportValue ? column.exportValue(row) : column.sortValue ? column.sortValue(row) : undefined;
    if (raw === null || raw === undefined) return '';
    if (raw instanceof Date) return raw.toISOString();
    return String(raw);
}

function escapeCsv(value: string): string {
    return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/**
 * Exports the given (already filtered/sorted) rows to a CSV download using each
 * column's `exportValue`, falling back to `sortValue`. Columns are emitted in
 * the supplied (visible) order.
 */
export function exportCsv<T>(columns: MegaGridColumn<T>[], rows: T[], name: string): void {
    const header = columns.map((c) => escapeCsv(c.header)).join(',');
    const body = rows.map((row) => columns.map((c) => escapeCsv(cellText(row, c))).join(',')).join('\n');
    const csv = `${header}\n${body}`;

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
